import { Button, darken, Divider, styled, Typography } from "@mui/material";
import StoreOutlinedIcon from "@mui/icons-material/LocalGroceryStoreOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { ReactNode } from "react";
import { CenteredContainer } from "../CenteredPageContainer";
import { primary } from "../../../wysiwyg/colors";
import BuilfirstLogo from "../../../assets/svg/builtfirst-logo.svg";

const Main = styled("div")(() => ({
  maxWidth: 470,
  display: "flex",
  flexDirection: "column",
  gap: 28,
  alignItems: "center",
}));

export const SiteMessageButton = styled(Button)(() => ({
  background: primary,
  borderRadius: 12,
  marginTop: 8,
  "&:hover": {
    background: darken(primary, 0.2),
  },
}));

const StyledText = styled(Typography)(() => ({
  maxWidth: "30rem",
  textAlign: "center",
  lineHeight: "1.4",
  fontSize: 24,
  opacity: "0.4",
}));

const StyledDivider = styled(Divider)(() => ({
  width: "115%",
  maxWidth: "80vw",
  borderColor: "#aaa",
}));

const ClosedIcon = styled("div")(() => ({
  position: "relative",
}));

const Logo = styled(BuilfirstLogo)(() => ({
  position: "absolute",
  bottom: 36,
  right: 42,
}));

const StyledCancelOutlinedIcon = styled(CancelOutlinedIcon)(() => ({
  position: "absolute",
  top: -15,
  right: -15,
  fontSize: 30,
}));

const StyledStoreOutlinedIcon = styled(StoreOutlinedIcon)(() => ({
  fontSize: 80,
}));

interface Props {
  title?: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
}

function SiteMessage({ title, subtitle, children }: Props) {
  return (
    <CenteredContainer>
      <style>
        {(() => `
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
    `)()}
      </style>
      <Main>
        <ClosedIcon>
          <StyledStoreOutlinedIcon />
          <StyledCancelOutlinedIcon />
        </ClosedIcon>
        <StyledText>{title}</StyledText>
        <StyledDivider />
        <StyledText>{subtitle}</StyledText>
        {children}
        <Logo />
      </Main>
    </CenteredContainer>
  );
}

export default SiteMessage;
